import { stripHtml } from "string-strip-html";

export function sanitizeText(text: string | null | undefined): string {
  if (text === undefined || text === null) {
    return "";
  }
  return stripHtml(text)
    .result.replace(/[<>[\]]/g, "")
    .trim();
}

export function normalizeImageUrl(url: string | null | undefined): string {
  if (!url) return "";
  const trimmed = url.trim();
  const stripped = trimmed.replace(/^(?:https?:)?\/\//, "");
  return stripped ? `https://${stripped}` : "";
}

export function formatDate(date?: string | Date | null): string | undefined {
  if (!date) {
    return undefined;
  }
  try {
    const parsed = new Date(date);
    if (isNaN(parsed.getTime())) {
      return undefined;
    }
    return parsed.toISOString();
  } catch {
    return undefined;
  }
}
